import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../../../context/authContext';
import { BgHolder, StyledLogo } from './LoginImg.styles';

function LoginImg() {
  const { user } = useContext(AuthContext);
  const { view } = useParams();
  const redirect = () => {
    if (!user?.hasProfileCreated && view === 'create-profile') {
      return `${process.env.REACT_APP_MAIN_URL}/business/create-profile`;
    }
    // return process.env.REACT_APP_MAIN_URL;
    return `${process.env.REACT_APP_MAIN_URL}/business/create-profile`;
  };
  return (
    <BgHolder>
      <StyledLogo href={redirect()} />
    </BgHolder>
  );
}

export default LoginImg;
